import { useMemo } from "react";

interface Permission {
  id: number;
  visualizar: boolean;
  editar: boolean;
  inserir: boolean;
  menu: {
    id: number;
  };
}

interface UserProfile {
  nome: string;
  permissoes: Permission[];
}

export const usePermissions = () => {
  const userData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("@MatriculaWeb:user") as any);
    } catch {
      return null;
    }
  }, []);

  const userProfile: UserProfile | null = userData?.usuario?.perfil || null;

  const isMaster = useMemo(() => {
    return userProfile?.nome === "MASTER";
  }, [userProfile]);

  const hasPermission = useMemo(() => {
    if (isMaster) return () => true;
    
    return (menuId: number, action: 'visualizar' | 'editar' | 'inserir' = 'visualizar') => {
      if (!userProfile?.permissoes) return false;
      
      const permission = userProfile.permissoes.find(p => p.menu.id === menuId);
      return permission?.[action] || false;
    };
  }, [userProfile, isMaster]);

  const canView = (menuId: number) => hasPermission(menuId, 'visualizar');
  const canEdit = (menuId: number) => hasPermission(menuId, 'editar');
  const canInsert = (menuId: number) => hasPermission(menuId, 'inserir');

  const canRecebimentoFinanceiro = useMemo(() => {
    return !!userData?.usuario?.acessoRecebimentoFinanceiro;
  }, [userData]);

  return {
    isMaster,
    hasPermission,
    canView,
    canEdit,
    canInsert,
    canRecebimentoFinanceiro,
    userProfile,
  };
};